export const VERSION = 'dev-master#0665dfe';
